// Mock data for Dviso Consulting

export const portfolioProjects = [
  {
    id: 1,
    title: "Contemporary Luxury Estate",
    type: "New Construction",
    location: "Miami, FL",
    completionDate: "2024",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NzEwNzUyNjl8MA&ixlib=rb-4.1.0&q=85",
    description: "Stunning modern estate featuring clean lines, floor-to-ceiling windows, and seamless indoor-outdoor living spaces."
  },
  {
    id: 2,
    title: "Modern Minimalist Villa",
    type: "New Construction",
    location: "Fort Lauderdale, FL",
    completionDate: "2023",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NzEwNzUyNjl8MA&ixlib=rb-4.1.0&q=85",
    description: "Architectural masterpiece with geometric design, premium materials, and sophisticated modern aesthetics."
  },
  {
    id: 3,
    title: "Modern Urban Home",
    type: "New Construction",
    location: "Miami, FL",
    completionDate: "2024",
    image: "https://images.unsplash.com/photo-1605297507265-a46432d9c44d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx0b3duaG91c2V8ZW58MHx8fHwxNzcxMDc4MjYyfDA&ixlib=rb-4.1.0&q=85",
    description: "Contemporary urban townhouse featuring geometric design, modern materials, and innovative architecture for city living."
  },
  {
    id: 4,
    title: "Sophisticated Urban Home",
    type: "New Construction",
    location: "Palm Beach, FL",
    completionDate: "2023",
    image: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NzEwNzUyNjl8MA&ixlib=rb-4.1.0&q=85",
    description: "Multi-level contemporary residence with innovative design, natural light optimization, and premium finishes."
  },
  {
    id: 5,
    title: "Contemporary Villa Estate",
    type: "New Construction",
    location: "Miami Beach, FL",
    completionDate: "2024",
    image: "https://images.unsplash.com/photo-1757264119016-7e6b568b810d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB2aWxsYSUyMHBvb2x8ZW58MHx8fHwxNzcxMDc4MDU3fDA&ixlib=rb-4.1.0&q=85",
    description: "Stunning modern white villa with swimming pool, expansive glass walls, and minimalist design showcasing luxury outdoor living."
  },
  {
    id: 6,
    title: "Luxury Living Room Design",
    type: "Interior Design",
    location: "Miami, FL",
    completionDate: "2024",
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221",
    description: "Elegant full modern living room with sophisticated furnishings, statement lighting, and carefully curated contemporary aesthetic."
  },
  {
    id: 7,
    title: "Modern Kitchen Excellence",
    type: "Interior Design",
    location: "Fort Lauderdale, FL",
    completionDate: "2023",
    image: "https://images.unsplash.com/photo-1762529716215-afd7400d7bd4",
    description: "Stunning open-concept modern kitchen with marble island, premium appliances, and seamless integration with dining area."
  },
  {
    id: 8,
    title: "Contemporary Bedroom Suite",
    type: "Interior Design",
    location: "Boca Raton, FL",
    completionDate: "2024",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWRyb29tfGVufDB8fHx8MTc3MTA4MTQ0OXww&ixlib=rb-4.1.0&q=85",
    description: "Luxury master bedroom with contemporary design, sophisticated lighting, premium bedding, and high-end finishes."
  },
  {
    id: 9,
    title: "Refined Living Space",
    type: "Interior Design",
    location: "Palm Beach, FL",
    completionDate: "2023",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92",
    description: "Complete modern living area showcasing full open-concept design with designer furnishings and architectural lighting throughout."
  }
];

export const services = [
  {
    id: 1,
    title: "Architecture & Design",
    description: "Professional architects and interior designers to bring your vision to life with innovative, functional designs.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Engineering Services",
    description: "Expert structural and MEP engineering ensuring safety, compliance, and efficiency in every project.",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Permits & Compliance",
    description: "Dedicated permits runners navigating the complex approval process, ensuring timely project starts.",
    icon: "FileCheck"
  },
  {
    id: 4,
    title: "Budgeting & Planning",
    description: "Comprehensive cost estimation, financial planning, and project scheduling to keep your project on budget and on time.",
    icon: "Calculator"
  },
  {
    id: 5,
    title: "Property Acquisition",
    description: "In-house realtors to find the perfect property that matches your investment goals and vision.",
    icon: "Home"
  },
  {
    id: 6,
    title: "Construction Management",
    description: "Turnkey project management from groundbreaking to final walkthrough, delivering quality on time.",
    icon: "HardHat"
  },
  {
    id: 7,
    title: "Financing Solutions",
    description: "Connected with trusted lenders to provide financing options that fit your budget and timeline.",
    icon: "DollarSign"
  },
  {
    id: 8,
    title: "Plumbing",
    description: "Licensed plumbing contractors for new installations, repairs, and full system upgrades for residential and commercial projects.",
    icon: "Wrench"
  },
  {
    id: 9,
    title: "Electrical",
    description: "Certified electrical contractors handling wiring, panel upgrades, lighting design, and code-compliant installations.",
    icon: "HardHat"
  },
  {
    id: 10,
    title: "Mechanical",
    description: "Expert mechanical contractors for HVAC systems, ventilation, and climate control solutions for any property.",
    icon: "Wrench"
  },
  {
    id: 11,
    title: "Civil Engineering",
    description: "Professional civil contractors for site work, grading, drainage, foundations, and structural infrastructure.",
    icon: "Building2"
  },
  {
    id: 12,
    title: "Landscaping",
    description: "Creative landscaping contractors for hardscaping, irrigation systems, tropical gardens, and outdoor living spaces.",
    icon: "Home"
  }
];

export const projectTypes = [
  "New Construction",
  "Residential Renovation",
  "Commercial Renovation",
  "Property Transformation",
  "Other"
];

export const budgetRanges = [
  "Under $50K",
  "$50K - $100K",
  "$100K - $250K",
  "$250K - $500K",
  "$500K - $1M",
  "Over $1M"
];

export const timelines = [
  "Less than 3 months",
  "3-6 months",
  "6-12 months",
  "Over 1 year",
  "Flexible"
];

export const ourWorkPhotos = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/8oww2b5p_Screenshot_20260214_170216_Photos.jpg",
    title: "Modern Residential Project",
    description: "Contemporary single-family home with modern design elements"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/fk6tz3q2_Screenshot_20260214_164828_Chrome.jpg",
    title: "Multi-Family Development",
    description: "Residential complex with tropical landscaping and amenities"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/5wtvjnri_Screenshot_20260214_164755_Chrome.jpg",
    title: "Community Living Spaces",
    description: "Modern apartment complex with pool and recreational areas"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/5b8z4b0f_Screenshot_20260214_163854_Mi%20Browser%20%281%29.jpg",
    title: "Contemporary Two-Story Home",
    description: "Modern residential design with clean lines and premium finishes"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/8htodoqs_6a837e53-9acd-4dfc-b648-651aaa36604f.jpg",
    title: "Urban Multi-Unit Building",
    description: "Three-story residential building with modern balconies"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/08zli4xf_Screenshot_20260214_163640_Chrome.jpg",
    title: "Luxury Coastal Resort",
    description: "Multi-story beachfront development with ocean views and luxury amenities"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/ez3nzgfs_NAD_CONDO_C1_rev05.jpg",
    title: "Modern Condominium Complex",
    description: "Contemporary multi-level residential building with architectural pergolas and balconies"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/19rz89en_Exterior%20CAM%202%20-%20Final.jpg",
    title: "Contemporary Townhomes",
    description: "Modern black and white townhouse development with tropical landscaping"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/s7t10nkv_image.jpg",
    title: "Modern Residential Community",
    description: "Contemporary townhouse complex with modern design and lush landscaping"
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/4iw368jx_b4c49e4b-bf30-4569-a897-ba632a64cfce%20%281%29.jpg",
    title: "Construction in Progress",
    description: "Modern home under construction showcasing structural framing and quality craftsmanship"
  },
  {
    id: 11,
    image: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/dv0gkqep_image%20%281%29.jpg",
    title: "Interior Construction Phase",
    description: "Open interior space showing quality structural work and contemporary design planning"
  },
  {
    id: 12,
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/cg526ti7_Image%205-6-26%20at%207.23%E2%80%AFPM.jpeg",
    title: "Modern Minimalist Home — Completed Exterior",
    description: "Sleek white exterior with wood accents, contemporary fencing, and professional landscaping"
  },
  {
    id: 13,
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/6fmzq0r3_Image%205-6-26%20at%207.16%E2%80%AFPM.jpeg",
    title: "Modern Minimalist Home — Front Facade",
    description: "Beautifully updated home with modern wood-look tile and white stucco exterior"
  },
  {
    id: 14,
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/fd49nqx1_Image%205-6-26%20at%207.19%E2%80%AFPM.jpeg",
    title: "Modern Minimalist Home — Construction Progress",
    description: "Active construction showing quality structural framing, roof installation, and craftsmanship"
  },
  {
    id: 15,
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/t69r5oik_Image%205-6-26%20at%207.20%E2%80%AFPM.jpeg",
    title: "Modern Minimalist Home — Before & After",
    description: "Before and after transformation — from dated pink property to modern white exterior with wood accents"
  },
  {
    id: 17,
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/lpyteik4_Imagen%20de%20ChatGPT%2028%20sept%202026%2C%2016_38_37.jpg",
    title: "Modern Minimalist Home — Completed Exterior",
    description: "Luxury modern minimalist home with white exterior, wood accent, circular driveway, and tropical landscaping"
  },
  {
    id: 18,
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/9g0groxj_Imagen%20de%20ChatGPT%2028%20sept%202026%2C%2016_38_43.jpg",
    title: "Modern Minimalist Home — Block Construction",
    description: "Concrete block construction phase showing exterior walls and structural openings"
  },
  {
    id: 19,
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/rwhwk4q7_Imagen%20de%20ChatGPT%2028%20sept%202026%2C%2016_38_47.jpg",
    title: "Modern Minimalist Home — Interior Framing",
    description: "Steel stud framing and wood roof trusses with lumber and materials staged for installation"
  },
  {
    id: 20,
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/rtboezad_Imagen%20de%20ChatGPT%2028%20sept%202026%2C%2016_38_51.jpg",
    title: "Modern Minimalist Home — Plumbing Rough-In",
    description: "Plumbing rough-in installation within steel stud framing showing PVC drain and supply lines"
  }
];

export const fixFlipProjects = [
  {
    id: 1,
    title: "Complete Home Transformation",
    beforeImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/kulj6e6i_IMG_9824.JPG",
    afterImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/iksz04bd_IMG_9823.JPG",
    description: "Transformed distressed tan property with missing garage into sleek modern white and wood contemporary home"
  },
  {
    id: 2,
    title: "Boarded Building Revival",
    beforeImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/ba6caqa0_IMG_9828.JPG",
    afterImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/e5t2gt85_IMG_9833.JPG",
    description: "Completely renovated severely damaged boarded building into beautiful 2-story modern white and wood home"
  },
  {
    id: 3,
    title: "Blue House Modern Makeover",
    beforeImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/h5tq8sfm_IMG_9826.JPG",
    afterImage: "https://customer-assets.emergentagent.com/job_construct-vision-6/artifacts/h5tq8sfm_IMG_9826.JPG",
    description: "Transformed dated blue property with worn exterior into clean modern white home with wood accents and updated landscaping"
  },
];
